import { BaseSidebarObject } from '@y42/gojs';

export class LinkArchetype extends BaseSidebarObject {
  constructor(public category = '') {
    super();
  }
}
